<template>
    <modal :open="open">
        <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-red-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Please slow down
                </h3>
                <div class="mt-2">
                    <p class="text-sm leading-5 text-gray-500">
                        You have reached an API limit for retrieving a status. Please consider slowing down refreshing the status.
                    </p>
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button type="button" @click="open = false" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                    Understood
                </button>
            </span>
        </template>
    </modal>
</template>

<script>
    export default {
        props: {
            open: {
                required: true,
                type: Boolean,
            },
        },
    }
</script>
